export default {
  name: "姓名",
  tel: "电话",
  save: "保存",
  confirm: "确定",
  cancel: "取消",
  delete: "删除",
  complete: "完成",
  loading: "加载中...",
  noMore: "没有更多了",
  noData: "暂无数据",
  maxRangePrompt: "最多可选择7天",
  telEmpty: "请填写电话",
  nameEmpty: "请填写姓名",
  nameInvalid: "请输入正确的姓名",
  confirmDelete: "确定要删除吗",
  telInvalid: "请输入正确的手机号",
  SelectYearMonthDay: "选择年月日",
  vanCalendar: {
    end: "结束",
    start: "开始",
    title: "日期选择",
    confirm: "确定",
    startEnd: "开始/结束",
    weekdays: ["日", "一", "二", "三", "四", "五", "六"],
    monthTitle: (year, month) => `${year}年${month}月`,
    rangePrompt: (maxRange) => `选择天数不能超过 ${maxRange} 天`,
  },
  vanCascader: {
    select: "请选择",
  },
  vanContactCard: {
    addText: "添加联系人",
  },
  vanContactList: {
    addText: "新建联系人",
  },
  vanPagination: {
    prev: "上一页",
    next: "下一页",
  },
  vanPullRefresh: {
    pulling: "下拉即可刷新...",
    loosing: "释放即可刷新...",
  },
  vanSubmitBar: {
    label: "合计：",
  },
  vanCoupon: {
    unlimited: "无使用门槛",
    discount: (discount) => `${discount}折`,
    condition: (condition) => `满${condition}元可用`,
  },
  vanCouponCell: {
    title: "优惠券",
    tips: "暂无可用",
    count: (count) => `${count}张可用`,
  },
  vanCouponList: {
    empty: "暂无优惠券",
    exchange: "兑换",
    close: "不使用优惠券",
    enable: "可用",
    disabled: "不可用",
    placeholder: "请输入优惠码",
  },
  vanAddressEdit: {
    area: "地区",
    postal: "邮政编码",
    areaEmpty: "请选择地区",
    addressEmpty: "请填写详细地址",
    postalEmpty: "邮政编码格式不正确",
    defaultAddress: "设为默认收货地址",
    telPlaceholder: "收货人手机号",
    namePlaceholder: "收货人姓名",
    areaPlaceholder: "选择省 / 市 / 区",
  },
  vanAddressEditDetail: {
    label: "详细地址",
    placeholder: "街道门牌、楼层房间号等信息",
  },
  vanAddressList: {
    add: "新增地址",
  },
  realName: "姓名",
  idCard: "身份证",

  unionManagement: {
    GuildRegistration: "公会入驻",
    GuildSettlementWelcomeLine1: "欢迎来到",
    GuildSettlementWelcomeLine2: "Rain Chat 公会",
    GuildSettlementFormBanner: "请填写加入公会信息",
    ApplicantID: "申请人ID",
    GuildName: "公会名称",
    PleaseGuildName: "请输入公会名称",
    PleaseGuildID: "请输入公会ID",
    PleaseInformation: "请输入你的联系方式",
    PlatformsWith: "合作过的平台",
    ListOfplatforms: "列举合作过的平台",
    GuildSize: "公会规模",
    EstimatedNumber: "预计公会主播人数",
    Notes: "注:可联系公会长或公会成员获取公会ID",
    Submit: "提交",
    SubmitSuccess: "提交成功",
    MyGuild: "我的公会",
    VoiceHallOnboarding: "语音厅入驻",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "请填写加入厅信息",
    VoiceHallName: "语音公会名称",
    PleaseVoiceHallName: "请输入语音公会名称",
    VoiceHallRealName: "真实姓名",
    PleaseVoiceHallRealName: "请输入真实姓名",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "请输入你的联系方式",
    PlatformsCollaborated: "合作过的平台",
    ListPlatformsCollaborated: "列举合作过的平台",
    VoiceHallScale: "语音公会规模",
    EstimatedAnchors: "预计语音厅主播人数",
    CertificationType: "认证类型",
    VoiceHall: "语音厅",
    VoiceGuild: "语音公会",
    HostName: "主播名称",
    GuildJoinDate: "加入公会时间",
    TotalMembers: "公会总人数",
    TotalPeople: "总人数",
    RoomNicknameLabel: "房间昵称",
    DataDetails: "数据详情",
    PleaseHostID: "请输入主播ID",
    Search: "搜索",
    KickOut: "踢出",
    NoData: "暂无数据",

    InformationData: "信息数据",
    Name: "姓名",
    PleaseID: "请与证件姓名保持一致",
    IdentityCard: "身份证",
    YourIDnumber: "你的身份证号码",
    IDPhoto: "身份证照片",
    PleasePhoto: "请上传你的身份证照片",
    FrontofID: "身份证正面",
    BackofID: "身份证反面",
    NotePlease:
      "注:请上传本人手持证件照片,要求面部清晰无遮挡, 同时证件照片及号码清晰可辨人",
    Country: "国 家",
    SelectCountryorRegion: "选择国家/地区",
    BankName: "银行名称",
    Pleasebankname: "请填写开户银行名称",
    BankCardNumber: "账号号码",
    Pleasebankcardnumber: "请填写银行卡号",
    BankCardHolder: "银行卡持有人",
    Pleasebankcardholder: "请填写银行卡持有人",
    PhoneNumber: "手机号",
    Enterphonenumber: "输入正确的手机号",
    Notebankaccount: "注:请输入银行预留手机号码",
    WhatsAppContactInformation: "WhatsApp联系方式",
    Pleaseownnumber: "请务必填写本人号码",
    Notecollaborationmatters:
      "注:公会填写的Whatsapp联系方式将视为唯一公会合作事宜联系方式",
    Email: "电子邮件",
    Pleaseemailaddress: "请务必填写本人邮箱",
    Notematters: "注:公会填写的邮箱将会被视为唯一合作公会事宜联系方式",
    BasicInformationSection: "基本信息",
    RemarksInformationSection: "备注信息",

    SpecialGiftDetails: "特效礼物明细",
    CurrentDate: "当前日期",
    GoldCoinTransactions: "金币流水",
    LiveStreamingDuration: "直播时长",
    GoldBeanEarnings: "金豆收益",
    EffectiveDays: "有效天数",
    WarningCount: "警告次数",

    give: "送",
    pleasewait: "请求中，请稍后...",

    JoinGuild: "加入公会",
    GuildId: "公会ID",
    PlaceholderGuildId: "请输入公会ID",
    PlaceholderInvitationCode: "请填写公会邀请码",

    InvitationCode: "邀请码",

    noMore: "没有更多了",

    Recommendation: "推荐人（选填）",
    nightLiveTime: "特殊时间",

    // 公会数据页面
    GuildTotalData: "公会总数据",
    StatDayUnit: "天",
    GuildIncome: "机构收益",
    AnchorIncome: "主播收益",
    EffectiveLive: "有效开播",
    EffectiveDays: "有效天",
    Income: "收益",
    Duration: "时长",

    // 加入我们页面
    JoinUs: "加入我们",
    JoinUsWelcome: "Hi,欢迎加入我们～",
    JoinUsSelectMethod: "请选择加入方式",
    JoinUsVideoGuild: "成为视频公会",
    JoinUsVideoGuildDesc: "您将会以视频主播为主",
    JoinUsAudioGuild: "成为语音公会",
    JoinUsAudioGuildDesc: "您将会以语音主播为主",
    JoinUsBack: "返回",
  },

  anchorCenter: {
    todayLiveData: "今日直播数据",
    time: "时间",
    duration: "时长",
    income: "幸运金豆收益",
    giftRecord: "礼物记录",
    withdraw: "提现",
    tipsUpdate: "注：当日数据每一分钟更新",
    overallData: "总体数据",
    totalDays: "总天数",
    totalDuration: "总时长",
    totalTurnover: "总幸运金豆",
    totalIncome: "总底薪",
    totalBeans: "总金豆",
    dataListMonth: "数据列表【{month}】",
    filter: "筛选",
    date: "日期",
    turnover: "流水",
    beans: "金豆",
    luckyBeans: "幸运金豆",
    specialBeans: "特效金豆",
    baseSalary: "底薪",
    totalIncomeLabel: "总收入",
    anchorTotalData: "主播总数据",
    anchorNicknamePlaceholder: "主播昵称",
    myGuild: "我的公会",
    guildNicknamePlaceholder: "公会昵称",
    anchorDataSection: "主播数据",
    todayDataTitle: "今日数据",
    liveStreamDuration: "直播时长",
    totalGoldBeans: "总金豆",
    nextDayLuckyReward: "次日幸运奖励",
    specialExtraReward: "特效额外奖励",
    weekLuckyReward: "本周幸运奖励",
    estimatedTotalEarnings: "预计总收益",
    grandTotal: "总计",
    zeroTime: "0时0分",
    year: "年",
    month: "月",
  },

  familyMain: {
    anchorList: "主播列表",
    anchorData: "主播数据",
    guildData: "公会数据",
    guildSummaryTitle: "公会汇总",
    guildList: "公会列表",
    micTime: "主播麦时",
    micTimeData: "主播麦时数据",
    beansDetail: "金豆明细",
    beansDetailData: "金豆明细数据",
    withdrawDetail: "提现明细",
    withdrawDetailData: "提现明细数据",
    roomData: "房间数据",
    roomDataData: "房间数据数据",
    distributeBeans: "分配金豆",
    distributeBeansData: "分配金豆数据",
    privateShareStats: "私信/分享统计",
    privateShareStatsData: "私信/分享统计数据",
    roomTurnover: "房间流水",
    roomTurnoverData: "房间流水数据",
    incomeRecord: "收益记录",
    incomeRecordData: "收益记录数据",
    knapsackGiftDetail: "背包礼物明细",
    knapsackGiftData: "背包礼物数据",
    roomFilterTitle: "房间筛选",
    roomFilterConfirm: "完成",
    allRooms: "全部房间",
    selectRoom: "选择房间",
  },
  anchorList: {
    countLabel: "【{count}名主播】",
    searchPlaceholder: "请输入主播ID",
    search: "搜索",
    joinTimeLabel: "加入时间：",
    noData: "暂无数据",
    nickNameFallback: "主播昵称",
    invalidUserId: "请输入数字ID",
  },

  salaryMain: {
    searchPlaceholder: "请输入主播id搜索",
    dateSelect: "日期选择",
    byDay: "按天",
    byRange: "按区间",
    searchTime: "搜索时间",
    to: "至",
    dataSummary: "数据汇总",
    totalMicTime: "总麦时",
    totalHeartGiftTurnover: "总幸运金豆",
    totalLuxuryGiftTurnover: "总金豆",
    member: "成员",
    anchorProfile: "主播资料",
    micTime: "麦时",
    heartGiftTurnover: "幸运金豆",
    luxuryGiftTurnover: "总金豆",
    roomNumber: "房间号",
    pleaseSelectTime: "请选择时间",
    pleaseEnterNumber: "请输入数字",
    selectAll: "全选",
    minute: "分",
    second: "秒",
    anchorTotalData: "主播总数据",
    totalSpecialEffectBeans: "总特效金豆",
    totalAllBeans: "总金豆",
  },

  micTime: {
    searchPlaceholder: "请输入主播ID",
    search: "搜索",
    dateSelect: "日期选择",
    today: "当天",
    thisWeek: "本周",
    lastWeek: "上周",
    totalMicTime: "总麦时",
    date: "日期",
    anchorInfo: "主播信息",
    micTime: "麦时",
    pleaseSelectTime: "请选择时间",
    selectAll: "全选",
    minute: "分",
    second: "秒",
  },

  anchroOtayonii: {
    dateSelect: "日期选择",
    byDay: "按天",
    byRange: "按区间",
    searchTime: "搜索时间",
    to: "至",
    dataSummary: "数据汇总",
    totalLuckyGift: "总幸运礼物",
    totalSpecialGift: "总特效礼物",
    totalKnapsackGift: "总背包礼物",
    anchorInfo: "主播信息",
    luckyGift: "幸运礼物",
    specialGift: "特效礼物",
    knapsackGift: "背包礼物",
    pleaseSelectTime: "请选择时间",
    selectAll: "全选",
  },

  roomCm: {
    dateSelect: "日期选择",
    today: "当天",
    thisWeek: "本周",
    lastWeek: "上周",
    dataSummary: "数据汇总",
    totalTurnover: "总幸运金豆",
    totalTurnoverBeans: "总金豆",
    date: "日期",
    heartGiftTurnover: "幸运金豆",
    specialGiftTurnover: "总金豆",
    room: "房间",
    pleaseSelectTime: "请选择时间",
    selectAll: "全选",
    minute: "分",
    second: "秒",
  },

  weekProfit: {
    dateSelect: "日期选择",
    time: "时间",
    type: "类型",
    beans: "金豆",
    pleaseSelectTime: "请选择时间",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "提现金额",
    withdrawStatus: "提现状态",
    NoData: "暂无数据",

    // 添加状态翻译
    UnderReview: "审核中",
    Processing: "打款中",
    Completed: "已到账",
    Rejected: "已驳回",
    Failed: "失败",

    Pending: "待处理",
    Success: "成功",
    NoMore: "没有更多了",
    PleaseWait: "请求中，请稍后...",
    PleaseSelect: "请选择",
    Date: "日期",
    RealAmount: "实到金额",
    Fee: "手续费",
    Status: "状态",
    Remark: "备注",
  },

  coinManagement: {
    myGoldenbeans: "我的金豆",
    Withdraw: "提现",
    ExchangeGoldCoins: "兑换金币",
    HostInformation: "主播信息",
    WithdrawalCurrency: "提现币种",
    SelectWithdrawalCurrency: "请选择提现币种",
    FiatCurrency: "法币",
    PleaseSelectWithdrawalCurrency: "请选择提现币种",
    tips: "注：",
    tipsp0: "提现比例：10,000金豆=0.5USD",
    tipsp1: "提现门槛：100,000金豆，提现只能以10,000的倍数进行（首次提现需要200,000金豆，提现成功后降至100,000）",
    tipsp2:
      "绑定提现账户，因异国打款方式多样、无固定证件等特性，后台添加账号为家族长时需支持多种认证类型【具体打款方式以目前情况为准】",
    tipsp3: "需要认证主播",
    tipsp4: "绑定手机号",
    tipsp5: "以上步骤任意一个未达成时，均无法提现，此时页面提示用户或引导开通",
    tipsp6: "① 仅提示",
    tipsp7: "② 跳转手机号绑定页，绑定完成后跳回上图页",
    tipsp8: "③ 跳转实名认证页，绑定完成后跳回上图页",
    tipsp9: "④ 跳转绑定账户页，绑定完成后跳回上图页",
    tipsp10: "提现会有一定的手续费，根据不同的渠道手续费也将不同。",

    tipsp11: "1.兑换比例：1000金豆=500金币",
    tipsp12: "2.最低5000金豆兑换，必须为1000的倍数",
    tipsp13: "3.兑换成功后不可撤回，请谨慎兑换",

    num: "数量",
    Custom: "自定义",
    PleaseEnter: "请输入",
    Redeem: "兑换",
    SelectType: "类型选择",
    GoldBeans: "金豆",
    GoldCoin: "金币",
    WithdrawalAmount: "提款金额",
    PleaseNum: "输入要提取的coin数量",
    All: "全部",
    Withdraw: "提现",

    Incomedetails: "收入明细",
    all: "全部",
    gift: "礼物",
    system: "系统",
    withdraw: "提现",
    exchange: "兑换",
    balance: "余额",
    Expensedetails: "支出明细",
    Nobeans: "没有可兑换金豆",

    Record: "交易记录",
    WithdrawalRecord: "提现记录",
  },

  contactUs: {
    Officialcustomerservice: "官方客服服务",
    ContactUs: "联系我们",
    Issueofguild: "公会入驻问题",
  },

  myInvitation: {
    MyGoldBeans: "我的金豆",
    Share: "分享邀请更多好友",
    CopyLink: "复制链接",
    GoldCoinEarnedToday: "今日获得金币",
    TotalGoldCoin: "累计金币",
    tips: "邀请绑定新用户充值任意金额都可获得1%金币奖励",
    tips2: "注册时间超过48小时无法绑定",
    MyInvitations: "我的邀请",
    BillingDetails: "账单明细",
    Total: "合计",
    People: "人",
    GoldCoinGiven: "赠送金币",
    GiveGoldCoin: "多送+",
    InvitationLink: "邀请链接",
    ShareQR: "二维码分享",
    InviteCount: "邀请人数",
    RevenueBeans: "收益金豆",
    InvitationDetails: "邀请明细",
    EarningsDetails: "收益明细",
    NickNameLabel: "用户昵称",
    SaveImage: "保存图片",
    QRScanHint: "扫描二维码或使用邀请链接加入",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "金豆",
    CommissionRate: "分成{rate}%",
  },

  userMisconduct: {
    title1: "内容违规 I",
    p1: "1.展示或传播受限制内容：",
    p2: "包括在 Rain Live 的私聊、直播或其他功能中传播色情、低俗、暴力或种族主义内容。",
    p3: "2.散布仇恨言论：",
    p4: "禁止发表针对宗教、种族、政治或国家身份的仇恨言论。",
    p5: "3.推广或拉人：",
    p6: "禁止通过直播、私聊或审核过的评论邀请用户加入其他应用程序或平台。",
    title2: "后果",
    p7: "涉及此类违规行为的账户、设备或 IP 地址可能会被封禁",

    title3: "内容违规 II",
    p8: "1.分享私人信息：",
    p9: "禁止通过 Rain Live 的直播、评论或私聊功能传播私人信息，例如电话号码、账号 ID、Facebook 账户、照片等。",
    p10: "2.账户滥用：",
    p11: "禁止向他人提供、出租或出售 Rain Live 账户。",
    p12: "3.利用私人信息：",
    p13: "禁止未经用户同意使用或传播其私人信息（照片、昵称等）以谋取私利或恶意攻击他人",
    title4: "后果",
    p14: "违规用户将被永久封号",
  },

  landingPage: {
    info1: "Rain直播圈",
    info2: "Apl内部采购",
    item1: "45K条点评",
    item2: "下载",
    item3: "等级3级 3+",
    btn: "下载",
    title: "关于Rain直播",
    content:
      "Rain直播是一款暖心的面向所有人的在线直播软件，包括语音、视频、娱乐、游戏等。平台聚集了高颜值主播，是一个有深度和内容的直播平台。激烈PK、活动不停，炫酷礼物、享受帝王般尊贵体验。",
    tips: "Rain直播在线在社交应用程序的热门免费列表中排名第一。",
  },

  // 公会数据
  // 主播数据
  // 我的工会
  equityLevel: {
    Experience: "经验值",
    Level: "当前等级",
    Berikutnya: "距离升级",
    title1: "等级特权",
    desc1: "等级越高，图标等级越尊贵，越容易得到用户的青睐",
    title2: "如何升级",
    desc2: "1、用户等级由您礼物消费的所得的经验值数量决定",
    desc3: "2、您可以通过每日送礼物消费来获得经验值进行等级提升",
    desc4: "3、幸运礼物，每消耗1金币获得1经验值",
    desc5: "4、特效礼物，每消耗1金币获得10经验值",
    title3: "等级特权",
    desc6: "等级越高，图标等级越尊贵，越容易得到用户的青睐",
    title4: "如何升级",
    desc7: "1、主播等级由您收到礼物的所得的经验值数量决定",
    desc8: "2、您可以通过每日收礼物数量来获得经验值进行等级提升",

    title6: "用户等级",
    title7: "等级",
    title8: "等级勋章",
    title9: "主播等级",
    title10: "累计经验值",

    LevelDescription: "等级说明",
    tabUser: "用户",
    tabEx: "Ex币",
    tabAnchor: "主播",
    titleOverview: "财富等级一览",
    nickNameUser: "用户昵称",
    nickNameAnchor: "主播昵称",
    nickNameEx: "用户昵称",
    exPrivilegeDesc: "等级越高，图标等级越尊贵，越容易得到用户的青睐",
    exDesc1: "1、Ex等级由您礼物消费的所得的经验值数量决定",
    exDesc2: "2、您可以通过每日送礼物消费来获得经验值进行等级提升",
    exDesc3: "3、幸运礼物，每消耗1金币获得1经验值",
    exDesc4: "4、特效礼物，每消耗1金币获得10经验值",
    anchorPrivilegeDesc: "等级越高，图标等级越尊贵，越容易得到用户的青睐",
    anchorDesc1: "1、主播等级由您收到礼物的所得的经验值数量决定",
    anchorDesc2: "2、您可以通过每日收礼物数量来获得经验值进行等级提升",
  },

  applyJoin: {
    tips1: "请输入您的 WhatsApp 账户",
    title2: "照片要求",
    tips2: "请展示您的脸部和上半身，并将双手摆成猫咪的姿势",
    tips3: "此照片将用于公司的审核，并且有关部门会对其保密。",
    tips4: "照片必须是您自己的。",
    title3: "视频要求",
    tops5: "视频必须展示您本人。",
    tips6: "视频时长应在 10 到 20 秒之间。",
    status1: "提交审核",
    status2: "审核中",
    status3: "审核成功",
    status4: "审核失败",
    LiveMode: "直播模式",
    Video: "视频",
    Voice: "语音",

    MP4: "请选择MP4格式视频",
    pngOrJpg: "请上传png或jpg格式图片",

    UploadingWait: "上传中，请稍后",
    CompleteInformation: "请完善信息",
    TabPersonalStreamer: "主播认证",
    TabJoinGuild: "加入公会",
    faceVerifyTitle: "人脸核验",
    faceVerifyPending: "待认证",
    faceVerifyVerified: "已认证",
    faceVerifyError: "您已认证其他账号，无法验证",
    faceVerifyRequired: "请先完成人脸核验",
    faceVerifyNotSupported: "当前环境不支持人脸核验",
    faceVerifyStart: "开始",
    faceVerifyRetry: "重试",
    faceVerifySuccess: "认证成功",
    faceVerifyFail: "认证失败",
  },
  cancelAccount: {
    title: "申请注销账号",
    tips: "以下信息将被清空且无法找回",
    p1: "注销账号所有信息将被永久删除（包括关注、粉等），你已购买的的增值业务将不再保留且不支持赋予其他账号 （vip、靓号、头像框等）",
    p2: "绑定的facebook、推特、苹果、谷歌账号将会解绑，解绑后可再次注册",
    p3: "你申请主播的信息会解绑，解绑后可再次绑定其他账号（如果你是直播主播用户，你的主播信息可再次认证开播)",
    p4: "账号注销后，账户剩余的金币、钻石、经验值、座驾、贵族等收益相关的数据将清空，如产生利益损失、由账号注销发起人承担",
    p5: "如果你是公会长，提交注销账号后公会将自动解散（公会解散后撤销申请也无法将公会复原）；如你是公会成员，注销账号后将自动退出公会 (15天内申诉期撤回注销可恢复）",
    p6: "如果你是家族长，提交注销账号时，需要先解散或退出家族;",
    p7: "如果你是家长成员（非家族长），提交注销账号时会立即退出家族 (15天内申诉期撤销注销不可恢复）",
    p8: "提交注销中请后，存在15天的申诉期。申请期内登录，自动取消注销。申诉日期到期后，账号自动注销且无法找回。如此期间内有非本人或误操作等原因找回账号，请联系客服申诉。(客服Whatsapp：+62 81188011180，或邮箱：rainlive888@gmail.com）",
  },

  Proxy: {
    Hello: "您好,",
    Welcome: "欢迎来到Rain Chat！",
    Account: "账号",
    Pleaseenter: "请输入",
    Password: "密码",
    Login: "登录",
    MyAgent: "我的代理",
    Nickname: "代理昵称",
    CoinBalance: "代理币余额",
    TransferRecord: "转账记录",
    Recharge: "充值",
    ExchangeProxyCoin: "兑换代理币",
    TransferInformation: "请填写转账信息",
    Reset: "重置",
    RecipientID: "对方ID",
    RecipientNickname: "对方昵称",
    TransferAmount: "转账金额",
    TotalTransferAmount: "总计",
    Transfer: "转账",
    KindReminder: "温馨提示",
    DoubleCheck: "请核对一下转账信息，确保无误",
    SelectAmount: "请选择需要充值的金额",
    SelectMonth: "选择月份",
    Username: "用户名称",
    TransferTime: "转账时间",
    AutoFill: "自动填充",
    Rechargeselection: "充值选择",
    ProxyCurrency: "代理币不足",
    PaymentAmount: "支付金额",
    PleaseSelectAmount: "请选择充值金额",
    GoldExchangeTitle: "金豆兑换代理币",
    GoldBalanceLabel: "金豆余额：",
    InputGoldPlaceholder: "输入金豆",
    AvailableProxyCoin: "可获得代理币",
    GiftProxyCoin: "赠送 {amount} 代理币",
    GiftBonusPercent: "赠送{bonus}%",
    Exchange: "兑换",
    Tip: "提示",
    ExchangeConfirmHtml:
      '您将使用<span class="green">{gold}</span>金豆兑换<span class="green">{coin}</span><br/>代理币，获赠<span class="orange">{gift}</span>代理币。',
    ExchangeSuccessTitle: "兑换成功",
    ExchangeSuccessText: "代理币已到账，请注意查收。",
    ExchangeFail: "兑换失败",
    RequestFail: "请求失败",
  },

  bd: {
    incomeDetail: {
      title: "收益详情",
      lastWeekIncome: "上周收益",
      totalIncome: "历史总收益",
      guildId: "公会ID",
      date: "日期",
      thisWeek: "本周",
      lastWeek: "上周",
      beforeLastWeek: "上上周",
      thisMonth: "本月",
      lastMonth: "上月",
      summary: "汇总",
      guildName: "公会名称",
      guildIncome: "工会收益",
      effectiveLive: "有效开播",
      myIncome: "我的收益",
      noData: "暂无数据",
      searching: "搜索收益数据",
      showingSummary: "显示汇总数据",
    },
    index: {
      title: "BD",
      guildCount: "公会数",
      weekEstimatedIncome: "本周预估收益",
      lastWeekIncome: "上周收益",
      inviteCode: "邀请码",
      searchPlaceholder: "请输入公会ID",
      lastWeek: "上周",
      guildName: "公会名称",
      guildId: "公会ID",
      weekIncome: "本周工会收益",
      myIncome: "我的收益",
      effectiveLive: "有效开播",
      bindDays: "绑定天数",
      copySuccess: "邀请码已复制",
      enterGuildId: "请输入公会ID",
      searchGuild: "搜索公会ID",
      search: "搜索",
      summary: "汇总",
      selectWeek: "选择周期",
      loading: "加载中...",
      loadFailed: "加载失败",
      networkError: "网络错误，请稍后重试",
    },
  },

  noble: {
    expireTime: "到期时间",
    canReceive: "可领取{coin}金币",
    receive: "立即领取",
    received: "已经领取",
    becomeNoble: "成为贵族",
    totalCanGet: "总计可获得{price}{totalCoin}金币",
    silver: "白银",
    gold: "黄金",
    platinum: "铂金",
    diamond: "钻石",
    obsidian: "黑曜",
    type: "类型",
    levelReward: "等级奖励",
    dailyExCoin: "每日Ex币",
    rechargeReward: "充值奖励",
    gameSupport: "游戏补偿",
    exclusiveDecoration: "专属装扮",
    decoration: {
      profileCard: "资料卡",
      bubble: "气泡框",
      vehicle: "座驾",
      avatarFrame: "头像框",
      badge: "铭牌",
    },
    dailyFreeExCoin: "每日免费{amount}Ex币",
    monthlyRechargeBenefit:
      "每月充值的{percent}%的额度作为权益金将于次月发放至账户中。",
    monthlyGameConsumptionBenefit:
      "每月游戏消耗金币的{percent}%，将于次月发放至账户中。",
    privileges: {
      getCoin: "领金币",
      avatarFrame: "头像框",
      medal: "勋章",
      vehicle: "座驾",
      purchaseNotification: "购买通知",
      chatBubble: "聊天气泡",
      colorfulNickname: "炫彩昵称",
      specialId: "靓号",
      mystery: "神秘人",
      exclusiveService: "专属客服",
      title: "专属权限",
      Effect: "房间入场特效",
    },
    receiveSuccess: "领取成功",
    contactOperation: "请联系运营获得",
    level1Recharge: "白银贵族 /30天",
    level2Recharge: "黄金贵族 /30天",
    level3Recharge: "铂金贵族 /30天",
    level4Recharge: "钻石贵族 /30天",
    level5Recharge: "黑曜贵族 /30天",
    vipCenterTitle: "贵族中心",
    expireTimeText: "有效期至",
    openVip: "充值开通",
    reachedLevel: "已达到该等级",
    stillNeedCoins: "还需充值 {amount} 金币",
    stillNeedCoinsToKeepGrade: "还需充值{amount}完成保级",
    stillNeedCoinsToActivate: "还需充值{amount}可开通{levelName}",
    keepGradeCompleted: "保级完成",
    keepGradeProgress: "保级进度：",
    progress: "进度",
  },

  bonusActivity: {
    title: "直播额外奖励",
    activityTime: "活动时间：2025年4月7日至2025年5月4日（UTC+8）",
    rewardRules: "奖励规则",
    reward: "奖励",
    totalReceived: "总计领取",
    bonus: "奖金",
    claim: "领取",
    claimed: "已经领取",
    notAchieved: "未达成",
    duration: "时长(小时)",
    target: "目标(金币)",
    note: "注：达成目标后，奖金次日可领取",
    activityCalendar: "活动日历",
    april: "四月",
    may: "五月",
    claimSuccess: "领取成功",
  },

  bonusActivityRule: {
    activityDescription: "活动说明",
    descriptionContent: "主播在基础奖励之上，还将额外获得Rain Live给予的奖励。",
    activityTime: "活动时间",
    resetTime: "每日0点(UTC+8)重置",
    pointsReward: "积分奖励",
    coinsReward: "金币奖励",
    participationTimes: "参与{times}次",
    points: "积分",
    exchange: "兑换",
    pointsMall: "积分商城",
    note: "注",
    rule1: "1、积分可通过完成每日积分任务获得",
    rule2: "2、积分商城的奖励将会不定期更换",
    rule3: "3、兑换成功后，积分不可退换，请谨慎兑换",
  },

  inviteFriends: {
    invitationEventTitle: "邀请活动",
    inviteAndEarnRewards: "邀请有奖",
    eventPeriod: "活动时间：4月7日 00:00 - 5月4日 23:59:59 (UTC+8)",
    invitationRecord: "邀请记录",
    eventDetails: "活动说明",
    week1DateRange: "第一周：4月7日-4月13日",
    totalInvitedExample: "已邀请人数",
    level1RewardText: "Lv.1  邀请20人                   20000金币",
    level2RewardText: "Lv.2  邀请50人                   50000金币",
    level3RewardText: "Lv.3  邀请100人                 100000金币",
    statusClaimed: "已领取",
    actionClaim: "领取",
    statusNotAchieved: "未达成",
    topUpRewardsLabel: "充值奖励：",
    copyInvitationLink: "复制邀请链接",
    rewardNote: "注：被邀请人充值时，你可获得对应金币的2%的奖励。",
    copySuccess: "复制成功",
    claimSuccessExample: "成功领取20000金币",
    userIDLabel: "User ID",
    userNameLabel: "User Name",
    timeLabel: "Time",
    topUpLabel: "Top-Up",
    eventPurposeTitle: "【活动目的】",
    eventPurposeDesc:
      "为感谢用户长期以来对 Rain Live 的支持与喜爱，平台特推出「邀请好友・多重有礼」活动，诚邀您与好友共享精彩直播体验！",
    eventDurationTitle: "【活动时间】",
    eventDateRange: "2025年4月7日至2025年5月",
    eventCycleDesc: "共 4 周，每周一 0 点(UTC+8)开启新周期奖励",
    rewardRulesTitle: "【奖励规则】",
    rewardRulesDesc1: "除本次活动奖励外，还正常享受原邀请奖励：",
    rewardRulesDesc2: "用户充值金币的2%将额外奖励给邀请人。",
    importantNotesTitle: "【注意事项】",
    importantNotesDesc:
      "⚠️ 禁止通过虚假账号、机器注册等恶意行为刷取奖励，一经发现将立即收回所有奖励，并可能限制账号功能；",
  },
  bonusPoints: {
    activityTime: "活动时间",
    resetTime: "每日0点(UTC+8)重置",
    pointsReward: "积分奖励",
    coinsReward: "金币奖励",
    participationTimes: "参与{times}次",
    points: "积分",
    exchange: "兑换",
    pointsMall: "积分商城",
    betSum: "当前流水",
    note: "注",
    rule1: "1、积分可通过完成每日积分任务获得",
    rule2: "2、积分商城的奖励将会不定期更换",
    rule3: "3、兑换成功后，积分不可退换，请谨慎兑换",
    coins: "金币",
    claim: "领取",
    claimed: "已经领取",
    notAchieved: "未达成",
    reach: "达到",
  },
  gameRanking: {
    notRanked: "未上榜",
    distanceToRank: "距离50名还差{points}积分",
    distanceToBeforeRank: "距离第{rankId}名还差{points}积分",
    rank1: "您已经是第一名了",
    today: "今天",
    yesterday: "昨天",
    ruleBtn: "规则",
    rules: {
      pointsStats: {
        title: "积分统计规则",
        conversion:
          "1. 积分转换标准：1金币等于活动中的1积分，参与者的积分将直接根据金币数量计算。",
        timeRange:
          "2. 统计时间范围：每日积分统计周期为00:00至23:59（UTC+8时区），超出此时间范围的金币数据将计入次日统计。",
      },
      ranking: {
        title: "排名和奖励规则",
        basis:
          "3. 排名依据：系统将根据参与者每日最终积分（即当日金币总数）进行降序排名，以确定每日排名。",
        rewards: "4. 奖励设置：",
        reward1: "排名第1：奖励250,000金币",
        reward2: "排名第2：奖励150,000金币",
        reward3: "排名第3：奖励100,000金币",
        reward4: "排名第4：奖励50,000金币",
        reward5: "排名第5：奖励50,000金币",
      },
      pointsCalculation: {
        description: "游戏流水最低5,000,000是获得活动奖励的必要条件。",
      },
      helpReward: {
        description:
          "助力奖励：若达到对应要求，但未领取到排名奖励时，会获得该助力奖励。",
      },
      turnoverRewards: {
        title: "流水奖励规则",
        turnover: "流水",
        reward: "奖励",
        turnover1M: "100万",
        reward10K: "10,000金币",
        turnover3M: "300万",
        reward30K: "30,000金币",
        turnover5M: "500万",
        reward50K: "50,000金币",
      },
      distribution: {
        title: "奖励发放规则",
        description:
          "对应每日排名的奖励将在次日统一发放。参与者可在次日登录活动页面或个人账户查看奖励领取状态。",
      },
      violation: {
        title: "违规处罚规则",
        description:
          "活动期间，严禁参与者使用系统漏洞、外挂或任何其他手段通过刷取积分（金币）进行作弊。如发现：",
        penalty1: "5. 首次违规者将取消当日奖励资格；",
        penalty2:
          "6. 情节严重或多次违规者将直接禁止参与本活动及后续相关活动，且不恢复参与权利。",
      },
    },
  },
  luckyAnchorRanking: {
    today: "今天",
    yesterday: "昨天",
    notRanked: "未上榜",
    distanceToRank: "距离50名还差{points}幸运金豆",
    distanceToBeforeRank: "距离第{rankId}名还差{points}幸运金豆",
    rank1: "您已经是第一名了",
    rules: {
      activity: {
        title: "活动说明",
        description: "统计主播每天的幸运金豆收益，根据此收益进行排名。",
      },
      ranking: {
        title: "排名奖励",
        rank: "名次",
        reward: "奖励金豆",
        decoration: "装扮",
        frameAndBubble: "头像框+气泡",
        frameOnly: "头像框",
        requirement: "获得排名奖励最低要求：150,000幸运金豆收益。",
      },
      helpReward: {
        title: "助力奖励",
        description: "未获得排名奖励的用户，也可获得幸运金豆收益目标奖励。",
        target: "目标",
        reward: "奖励",
      },
      distribution: {
        title: "奖励发放",
        description: "奖励将于次日发放。",
      },
      statistics: {
        title: "统计说明",
        description: "统计的是幸运金豆收益。",
      },
    },
  },

  // 红包雨活动
  redEnvelopeRain: {
    countdownTitle: "抢币倒计时",
    startNow: "立即开抢",
    rules: "规则",
    timeSlotPrize: "时段参与奖",
    winningDetails: "中奖明细",
    activityRules: "活动规则",
    congratulations: "恭喜中奖",
    sorryNoWin: "很遗憾未中奖！",
    coin: "币",
    rulesContent: {
      rule1: "1.活动时间：9月26日~10月15日",
      rule2:
        "2.活动规则：红包每次开启之前，在直播间完成3次发言，即可领取红包。",
      rule3: "3.每天有20:00~00:40都可领取红包，每20分钟一次。",
      rule4: "4.不同时间段内，可重复参加",
      rule5: "5.领取的金币将实时发放到您的账户",
    },
    timeStatus: {
      inProgress: "进行中",
      notStarted: "未开奖",
      finished: "已开奖",
    },
    chatRequirement: "直播间发言3条可领，当前发言{count}条",
  },

  // 公会活动
  guildActivity: {
    ruleBtn: "规则",
    tabThis: "本期",
    tabLast: "上期",
    activityRules: "活动规则",
    rulesContent: {
      activityTime: "活动时间：9月29日开始",
      rankingRewards: "排名奖励",
      requirements: "要求",
      rewardDistribution: "奖励发放",
      rewardList: {
        first: "第一名：1000000金豆",
        second: "第二名：500000金豆",
        thirdToFifth: "第3-5名：250000金豆",
        sixthToTenth: "第6-10名：100000金豆",
        eleventhToTwentieth: "第11-20名：50000金豆",
      },
      requirementText:
        "机构主播当周必须完成至少30场直播，每位主播每天直播超过2小时算作一次",
      distributionText: "奖励将于第二周发放",
    },
  },

  // 魅力榜/消费榜排行榜
  charmRanking: {
    charmRanking: "魅力榜",
    consumptionRanking: "消费榜",
    dailyRanking: "日榜",
    weeklyRanking: "周榜",
    userNickname: "用户昵称",
    distanceToPrevious: "距前一名",
    noRankingData: "暂无排行榜数据",
    requestFailed: "请求失败",
  },

  // 邀请活动
  inviteActivity: {
    title: "邀请3人必得奖励",
    rule: "规则",
    alreadyJoined: "已加入",
    inviteImmediately: "立即邀请",
    callNumber: "邀请",
    myRewards: "我的奖励",
    claim: "领取",
    claimed: "已领取",
    people: "人",
    inviteFriends: "邀请朋友",
    processTitle: "邀请流程：",
    step1: "1.发送链接给朋友",
    step2: "2.朋友下载并注册",
    step3: "3.获得免费金币",
    rulesTitle: "邀请规则",
    rulesContent: {
      rule1: "邀请达到3人时，可领取16666金豆",
      rule2: "邀请达到25人时，可再领取36666金豆",
      rule3: "邀请达到100人时，可再领取88888金豆总计可领142220金豆。",
      rule4: "奖励于活动页面手动领取。",
      rule5: "严禁恶意刷取人数，若发现将进行封号处理",
    },
    close: "关闭",
    inviteFeatureComingSoon: "邀请功能即将上线",
    rewardReceived: "成功获得 {amount} 金币！",
  },

  // 赠送金币页面
  giftGoldCoins: {
    maxGiftableCoins: "最大可赠送金币",
    giftAmount: "赠送金币数量",
    customAmount: "自定义赠送金币数量",
    enterAmount: "请输入金额",
    quantity: "数量",
    giftToOtherAccounts: "赠送至其他账号",
    exceedMaxAmount: "金额不能超过最大可赠送数量",
    amountSet: "金额设置成功",
    invalidAmount: "请输入有效金额",
    selectValidAmount: "请选择有效金额",
    confirmTitle: "确认赠送",
    confirmMessage: "确定要赠送 {amount} 金币吗？",
    giftSuccess: "赠送成功",
    giftId: "赠送ID",
    enterGiftId: "请输入ID",
    pleaseEnterGiftId: "请输入赠送ID",
    giftCompleted: "赠送完成！",
    giftedToId: "赠送至ID",
    networkError: "网络错误，请稍后重试",
    confirm: "确认",
  },

  // 装扮商店
  shop: {
    headerTitle: "个人装扮",
    back: "返回",
    shoppingBag: "购物袋",
    loading: "加载中...",
    noProducts: "暂无商品",
    unnamedProduct: "未命名商品",
    day: "天",
    myCoins: "我的金币",
    exchangeNow: "立即兑换",
    notSelected: "未选中",
    loginExpired: "登录失效，请重新登录",
    categoryNotExists: "分类不存在",
    loadFailed: "加载失败",
    loadFailedRetry: "加载失败，请重试",
    pleaseSelectProduct: "请先选择商品",
    productNotExists: "商品不存在",
    insufficientCoins: "金币不足，需要{amount}金币",
    exchangeSuccess: "兑换成功",
    exchangeFailed: "兑换失败",
    categories: {
      hot: "热门",
      avatarFrame: "头像框",
      entryEffect: "进场特效",
      chatBubble: "聊天气泡",
      mount: "坐骑",
    },
    recharge: "充值 >",
    validityPeriod: "有效期:",
    myCoinsLabel: "我的金币:",
  },
  myDecoration: {
    headerTitle: "我的装扮",
    back: "返回",
    noWearingDecoration: "暂无选中的穿戴装扮",
    loading: "加载中...",
    noDecoration: "暂无装扮",
    unnamedDecoration: "未命名装扮",
    permanent: "永久",
    wearing: "穿戴中",
    pleaseSelectDecoration: "请选择装扮",
    removeDecoration: "卸下装扮",
    wearNow: "立即穿戴",
    pleaseSelectDecorationFirst: "请先选择装扮",
    decorationNotExists: "装扮不存在",
    loginExpired: "登录失效，请重新登录",
    loadFailed: "加载失败",
    loadFailedRetry: "加载失败，请重试",
    wearSuccess: "穿戴成功",
    wearFailed: "穿戴失败",
    previewAnimation: "预览动画",
    categories: {
      hot: "热门",
      avatarFrame: "头像框",
      entryEffect: "进场特效",
      chatBubble: "聊天气泡",
      mount: "坐骑",
    },
  },
  // 圣诞活动/幸运星活动
  christmasActivity: {
    dailyLuckyStar: "每日幸运星",
    weeklyLuckyStar: "每周幸运星",
    startTime: "开始时间:",
    obtainedCount: "获得个数",
    moreChance: "数量越多机会越多",
    participated: "已参与",
    notParticipated: "未参与",
    historyRecord: "历史记录",
    myRecord: "我的记录",
    noRecord: "暂无记录",
    loading: "加载中...",
    noMore: "没有更多了",
    coin: "金币",
    goldCoin: "金豆",
    unit: "个",
    notWon: "未中奖",
    conditionNotMet: "条件未满足",
    claimSuccess: "领取成功",
    getRecordFailed: "获取记录失败",
    rules: {
      title: "活动规则",
      rule1: "每日幸运星",
      rule2: "每日幸运星活动，所有用户可参与。",
      rule3:
        "向主播赠送对应礼物时，可获得礼物个数累计，当赠送的礼物数量满足要求时，即可参与到红包开奖中，每次都将会有幸运儿获得金币奖励。",
      rule4: "赠送礼物个数越多，获奖机会越高",
      rule5: "每周幸运星",
      rule6: "周幸运星活动，所有的主播可参与。",
      rule7:
        "当收到用户赠送的对应礼物时，会获得数量累计，收到足够的礼物数量时，可参与周幸运星红包开启，每次都将有幸运儿获得奖励。",
      rule8: "获得礼物个数越高，获奖机会越高",
      rule9: "其他说明",
      rule10: "此次活动为福利大回馈。",
      rule11: "仅向其他主播赠送时，可累计个数。",
      rule12: "严禁利用漏洞获得奖励。",
      rule13: "每个时间段的奖励将自动发放，可查看获奖记录，了解中奖情况",
    },
  },

  // 幸运星积分排行活动
  fortuneStarActivity: {
    points: "积分",
    pointsRanking: "积分排行",
    currentRoundPoints: "本场积分",
    lastRoundPoints: "上场积分",
    defaultUserName: "用户名称",
    noData: "暂无数据",
    activityRules: "规则",
    historyRecord: "历史记录",
    earnedPoints: "获得积分",
    participated: "已参与",
    notParticipated: "未满足",
    myRecord: "我的记录",
    userId: "ID",
    userNickname: "用户昵称",
    sessionTime: "场次时间",
    winningStatus: "中奖情况",
    won: "已中奖",
    notWon: "未中奖",
    rules: {
      rule1: "活动期间，用户通过赠送指定礼物可获得积分",
      rule2: "积分将实时累计，可查看当前积分排名",
      rule3: "活动结束后，排名靠前的用户将获得丰厚奖励",
      rule4: "严禁使用任何作弊手段获取积分，违者将取消资格",
      rule5: "活动最终解释权归平台所有",
    },
  },

  // 盲盒活动
  blindBox: {
    title: "玩法介绍",
    ruleTitle: "玩法介绍",
    rule1:
      "每{price}金币可开{text}一次，用户赠送该礼物后可变出不同的礼物，变出礼物将会自动赠送给所指定的麦上用户",
    rule2: "赠送{text}用户在该礼物所变出的礼物自动送出后可获得对应的金豆。",
    rewardTip: "奖励提示",
    probabilityDesc: "具体概率如下：",
    prize: "奖品",
    probability: "概率",
    value: "价值",
  },

  taskHub: {
    tabCenter: "任务中心",
    tabAnchor: "主播任务",
    signTitle: "7日签到",
    signStreakBefore: "连续签到 ",
    signStreakAfter: " 天",
    signBtn: "签到",
    signBtnDone: "已签到",
    signPeriod: "本期签到: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "头像框",
    activeTasks: "用户活跃任务",
    timeLeft: "剩余时间: {t}",
    claimable: "可领取",
    inProgress: "进行中",
    rewardGain: "可获得 {n} EX币",
    taskWatchLive: "观看直播三十分钟",
    taskFollowHosts: "关注3名主播",
    taskSpeakRooms: "在不同房间发言3次",
    taskGiftCoins: "消费100金币用于送礼",
    taskGameCoins: "消费100金币用于游戏",
    taskRechargeToday: "今日充值一次",
    unitMinutes: "分钟",
    unitHosts: "名主播",
    unitTimes: "次",
    unitCoins: "金币",
    unitDays: "天",
    toastSigned: "签到成功",
    toastClaimed: "领取成功",
    claimSuccessTitle: "领取成功",
    claimSuccessOk: "知道啦",
    toastInProgress: "任务进行中",
    toastLoadFail: "加载失败",
    claimed: "已完成",
    toastRefreshed: "已刷新",
    anchorActivity: "活动",
    weekDurationTitle: "周时长活动",
    activityPeriod: "活动周期",
    weekLiveDuration: "本周开播时长",
    weekRank: "本周排名",
    claimableReward: "可领取奖励",
    effectExtraTitle: "特效额外奖励",
    effectBeansToday: "当天收到特效金豆",
    rewardDate: "奖励日期 {date}",
    claimableAmount: "可领取",
    claimNow: "立即领取",
    claimedToday: "当天已领取:",
    effectNote: "注：当天奖励最晚于次日1:00 (UTC+8) 前领取",
    todayData: "Today Data",
    todayLiveDuration: "当天直播时长",
    liveHintShort: "还差{remain}",
    needMoreBeans: "还差{n}",
    toastNoClaimable: "暂无可领取奖励",
    toastClaimPending: "领取接口待对接",
    luckyBeans: "幸运金豆",
    nextDayLucky: "次日幸运奖励",
    upgradeBeansTitle: "升级领取金豆",
    upgradeReward: "升级奖励",
    weekData: "Week Data",
    totalLiveDuration: "总直播时长",
    validDays: "有效天数",
    weekLuckyReward: "本周幸运奖励",
    dayDataTitle: "今日数据",
    monthDataTitle: "当月数据",
    weekDataTitle: "当周数据",
    monthLiveDuration: "当月直播时长",
    weekLiveDuration: "当周直播时长",
    specialBeans: "特效金豆",
    totalBeans: "总金豆",
  },

  pcOfficial: {
    navHome: "首页",
    navLive: "实时直播",
    navGameHall: "游戏大厅",
    received: "收到",
    heroTagline: "全球领先的 Web4 娱乐平台",
    heroTaglineSub:
      "性感主播7*24小时实时互动，顶级链游体验。基于去中心化技术，确保每一笔交易即时奖励，公平公正",
    downloadNow: "立即下载",
    giftCoin: "Ex币",
    giftAvatarFrame: "头像框",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "热门主播推荐",
    recommendSub: "万千女神实时互动，带你领略P2E链游魅力",
    hotGamingTitle: "热门游戏",
    hotGamingSub: "真实玩家，真实排名。你会是下一个传奇吗？",
    casinoTitle: "娱乐城",
    casinoDesc1: "与真人荷官同场竞技，畅玩百家乐，",
    casinoDesc2: "轮盘与 21 点，高清沉浸体验",
    slotsTitle: "老虎机",
    slotsDesc: "海量高品质老虎机，98.5% RTP 高回报",
    gamingTitle: "游戏",
    gamingDesc: "不止转盘，体验多人竞技技巧游戏",
    whyTitle: "为什么选择 Rain Live",
    whyItem1Title: "公平公正",
    whyItem1Desc: "经审计 RNG，保证每局公平",
    whyItem2Title: "极速到账",
    whyItem2Desc: "提现快速，到账及时",
    whyItem3Title: "匿名隐私",
    whyItem3Desc: "无需个人信息，100% 隐私保护",
    whyItem4Title: "去中心化",
    whyItem4Desc: "链上透明、安全可信",
    terms: "服务条款",
    privacy: "隐私政策",
    navRecharge: "充值",
    rechargeAccountTitle: "充值账号",
    idLogin: "ID 登录",
    accountIdLabel: "账号ID：",
    accountIdPlaceholder: "请输入账号ID",
    confirm: "确认",
    defaultUserName: "用户名",
    userIdWithValue: "ID:{id}",
    switchAccount: "切换账号",
    rechargeQuantityTitle: "充值数量",
    goToPay: "前往支付",
    topUpAmountTitle: "充值金额",
    pay: "支付",
    channelDefault: "支付渠道",
    toastInvalidAccountId: "请输入有效账号ID",
    toastNoTokenAfterLogin: "登录成功但未获取到 token",
    toastLoginFailed: "登录失败",
    toastCoinPackagesFailed: "获取充值列表失败",
    toastPayChannelsFailed: "获取支付渠道失败",
    toastOrderParamsMissing: "订单参数缺失，无法发起支付",
    toastNoPayUrl: "支付地址不存在",
    toastCreateOrderFailed: "创建支付订单失败",
    rainLiveRecharge: "Rain Live 充值",
    selectCountryTitle: "选择国家/地区",
    selectChannelTitle: "选择支付渠道",
    rechargeLoading: "加载中...",
    rechargePackagesEmpty: "暂无可用充值档位",
    rechargeLoginHint: "请先使用 ID 登录",
  },

  rainChatOfficial: {
    navHome: "首页",
    navContact: "联系我们",
    navRecharge: "充值",
    heroSub:
      "在RainChat，分享生活点滴，结识有趣的人，开启视频、语音聊天和直播互动的新体验。",
    feature1Title: "动态分享",
    feature1Desc: "分享生活瞬间，发现世界的美好与感动",
    feature2Title: "视频直播",
    feature2Desc: "随时随地开启直播，与观众实时互动，分享精彩时刻",
    feature3Title: "语音直播",
    feature3Desc: "用声音传递魅力，语音直播让交流更直接，更温暖。",
    feature4Title: "视频&语音聊天",
    feature4Desc: "一对一或群组聊天，高清视频语音，让沟通更真实",
    privacy: "隐私政策",
    terms: "用户协议",
    copyright: "©2026 RainChat. PT SEJAHTERA GROUP INDONESIA.",
    contactEmailLabel: "邮箱",
    contactHint: "如有任何问题或合作意向，欢迎通过邮件与我们联系。",
    linkNotReady: "下载链接暂未配置",
    appNotDetected: "未检测到APP，请下载",
    appStore: "App Store",
    googlePlay: "Google Play",
    android: "Android",
    downloadBtn: "下载",
    coinRechargeTitle: "金币充值",
    packageBonus: "多送+{count}金币",
  },

  // 直播时长奖励活动
  liveDuration: {
    tabthisWeek: "本週",
    tablastWeek: "上週",
    eventTime: "活动时间：{time}",
    rewardCoin: "奖励金币",
    liveHours: "直播时长",
    myRank: "我的排名",
    zeroHours: "0小时",
    hoursOnly: "{hours}小时",
    minutesOnly: "{minutes}分钟",
    hoursMinutes: "{hours}小时{minutes}分钟",
  },

  // USDT 充值订单支付页
  topUpUsdt: {
    orderNo: "订单号",
    copy: "复制",
    copyOrderNo: "复制订单号",
    copyAddress: "复制收款地址",
    productName: "RainChat 金币",
    quantityUnit: "× {count} 枚",
    orderAmount: "订单金额",
    scanToPay: "扫码支付",
    scanTip: "使用钱包 App 扫描二维码完成支付",
    qrAreaAlt: "支付二维码区域",
    qrCodeAlt: "支付二维码",
    receivingAddress: "收款地址",
    validityPrefix: "有效期",
    validityMinutes: "{minutes} 分钟",
    validitySuffix: "，请尽快支付",
    orderNoCopied: "订单号已复制",
    addressCopied: "收款地址已复制",
    nothingToCopy: "暂无可复制内容",
    copyFailed: "复制失败，请手动复制",
    promptTitle: "提示",
    rechargePrompt: "如已充值，请点击完成充值",
    cancel: "取消",
    completeRecharge: "完成充值",
    rechargeCompleted: "✔充值完成",
    rechargeCompletedText: "充值完成",
    rechargePending: "目前查询未到账，可能存在延迟，到账后金币将会自动添加",
    gotIt: "明白了",
  },

  // 体验币幸运转盘活动
  luckyTurntable: {
    draw: "抽奖",
    drawing: "抽奖中",
    task: "任务",
    recharge: "充值",
    historyRecord: "历史记录",
    balanceLabel: "体验币余额：",
    exGradeTip: "Ex等级Lv.{grade} · 需要 Lv.{level} 参与",
    got: "获得",
    defaultNotice: "用户昵称 {got} 体验币",
    insufficientBalance: "余额不足",
    exGradeNotMet: "Ex等级不达标",
    configLoadFailed: "配置加载失败，请稍后重试",
    recordLoadFailed: "记录加载失败，请稍后重试",
    drawResultError: "抽奖结果异常，请稍后重试",
    drawFailed: "抽奖失败，请稍后重试",
    winTitle: "恭喜获得",
    winConfirm: "知道啦",
    loading: "加载中...",
    noRecord: "暂无记录",
    noMore: "没有更多了",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "邀请活跃",
    tabWelfare: "七天福利",
    tabMic: "上麦奖励",
    inviteTitle: "邀请用户活跃奖励",
    yesterdayData: "昨日数据",
    yesterdayActive: "昨日活跃人数",
    goldBean: "金豆",
    todayDataRealtime: "今日数据（实时）",
    todayActive: "今日活跃人数",
    peopleUnit: "人",
    estimateReward: "预计奖励",
    claimTomorrowTip: "次日10:00可领取",
    claimAt10: "10点可领取",
    claimYesterday: "领取昨日奖励",
    claimed: "已领取",
    noReward: "暂无奖励",
    viewDetail: "查看明细",
    welfareTitle: "新主播七天福利",
    personalNewHost: "个人新主播",
    rule: "规则",
    welfareRemain: "福利剩余时间",
    dayUnit: "天",
    minuteUnit: "分钟",
    day1: "第1天",
    day7: "第7天",
    todayData: "今日数据",
    todayMicDuration: "今日上麦时长",
    claimableBean: "可领取金豆",
    claimReward: "领取奖励",
    claimTodayReward: "领取今日奖励",
    todayCanClaim: "今日还可领{amount}",
    needMic60: "今日上麦60分钟即可领取",
    needMic120: "今日上麦120分钟即可领取",
    todayClaimedAll: "今日奖励已领完",
    becomeAnchor: "成为主播，即可领奖",
    totalClaimed: "总计领取金豆",
    welfareRulesTitle: "7天福利规则",
    welfareCondTitle: "1. 参与条件：",
    welfareCond1: "a. 自注册起7天内的新用户",
    welfareCond2: "b. 完成主播认证",
    welfareCond3: "c. 未加入公会",
    welfareRewardTitle: "2. 奖励说明",
    welfareReward1: "a. 每日上麦并开麦可以累计时长。",
    welfareReward2: "b. 每1小时，可以领取5,000金豆。",
    welfareReward3: "c. 单日最高可领取2小时，10,000金豆。",
    welfareReward4: "d. 最多可领取70,000金豆奖励。",
    welfareNoteTitle: "3. 注意事项。",
    welfareNote1: "a. 奖励每日手动领取",
    welfareNote2: "b. 若注册时间超过7日，则无法再次领取。",
    welfareNote3: "c. 数据每10-15分钟更新",
    welfareNote4: "d. 若发现利用不公正的手段刷取奖励，将会封号处理。",
    micRulesTitle: "上麦奖励规则",
    micCondTitle: "1. 参与条件：",
    micCond1: "a. 完成主播认证",
    micCond2: "b. 未加入公会。",
    micRewardTitle: "2. 奖励",
    micGradeLevel: "等级",
    micGradeIncome: "近7天收益金豆",
    micGradeHourly: "时薪 (金豆/h)",
    micGradeDaily: "单日上限",
    micGradeBeans: "{beans} 金豆 ({usd})",
    micGradeDailyLimit: "2 小时",
    micExplainTitle: "3. 说明",
    micExplain1:
      "a. RainChat会根据你的近7天金豆收益，进行等级核算（当前+前六天）",
    micExplain2: "b. 数据每10-15分钟更新。",
    micExplain3: "c. 根据当前等级，可领取对应等级下的金豆时薪奖励。",
    micExplain4: "d. 奖励手动领取，领取后奖励实时到账。",
    micExplain5: "e. 若当天未领取，奖励会过期。",
    micExplain6: "f. 单日可领取2小时时薪。",
    micExplain7:
      "g. 近七天金豆收益超SS上限时。每多70万金豆收益，时薪核算多2万。",
    micExplainExample: "例：7,700,000金豆，时薪220,000。",
    micExplain8:
      "h. 享受“7天福利”时，“等级I”时薪奖励不可用。“7天福利”结束后可正常领取。",
    micExplain9: "i. 若发现利用不公正的手段刷取奖励，将会封号处理。",
    nextRefresh: "下次刷新",
    recent7Days: "最近7日",
    micRangeTip: "今天+前6天\n需要成为主播",
    totalIncome: "总收入",
    upgradeDesc: "还差{remain}可升级，奖金增加{bonus}",
    ssBonusDesc: "每多700K金豆，奖金增加20K金豆",
    completeAllTask: "完成所有任务可获得",
    claim: "领取",
    grantSuccess: "奖励发放成功",
    thisTimeGot: "本次获得",
    grantedToAccount: "奖励已发放至您账户",
    gotIt: "明白了",
    claimFail: "领取失败，请稍后重试",
    micTaskName: "今日开播/上麦{minutes}分钟",
  },
  guildApply: {
    "title": "公会申请",
    "pendingCount": "{count}条待处理",
    "autoApproveTip": "超过7天未处理的申请将自动同意，请及时审核",
    "joinRequest": "（{rainId}）想加入公会",
    "daysRemaining": "剩余{days}天",
    "appliedWithinOneDay": "一天内申请",
    "appliedDaysAgo": "{days}天前",
    "boundDays": "绑定天数：{days}天",
    "incomeTier": "收入等级：{level}",
    "applyToGuild": "申请公会",
    "reject": "拒绝",
    "approve": "同意",
    "noPendingRequests": "暂无待处理申请",
    "approved": "已同意申请",
    "rejected": "已拒绝申请",
    "approvalConfirmTitle": "提示",
    "approvalConfirmMessage": "同意后，对方将加入他人公会。并且不再为你提供收入分佣",
    "back": "返回",
    "pendingList": "待处理申请",
    "noToken": "未获取到登录凭证",
    "listLoadFailed": "申请列表加载失败",
    "listLoadFailedRetry": "申请列表加载失败，请稍后重试",
    "operationFailedRetry": "操作失败，请稍后重试"
  },
  inviteFriendsNew: {
    "inviteRanking": "邀请排行榜",
    "messages": "消息",
    "totalRewards": "邀请奖励总计",
    "earnings": "收益",
    "totalValue": "总价值",
    "viewDetails": "查看明细",
    "inviteStats": "邀请统计",
    "totalInvites": "累计",
    "todayInvites": "今日",
    "details": "详情",
    "inviteFriends": "邀请好友",
    "copyLink": "复制专属链接",
    "close": "关闭弹窗",
    "saveImage": "保存图片",
    "inviteModal": "邀请好友弹窗",
    "rightTools": "页面入口",
    "noToken": "未获取到登录凭证",
    "rewardsLoadFailed": "邀请收益加载失败",
    "rewardsLoadFailedRetry": "邀请收益加载失败，请稍后重试",
    "inviteInfoLoadFailed": "邀请信息加载失败",
    "inviteInfoLoadFailedRetry": "邀请信息加载失败，请稍后重试",
    "linkNotReady": "邀请链接尚未加载完成",
    "linkCopied": "邀请链接已复制",
    "copyFailedRetry": "复制失败，请稍后重试",
    "saveFailedRetry": "保存图片失败，请稍后重试"
  },
  inviteRanking: {
    "title": "排行榜",
    "earningsRank": "收益排名",
    "inviteRank": "邀请排名",
    "day": "日",
    "week": "周",
    "total": "总",
    "people": "人",
    "noToken": "未获取到登录凭证",
    "loadFailed": "排行榜加载失败",
    "loadFailedRetry": "排行榜加载失败，请稍后重试"
  },
  inviterInformation: {
    "title": "我的邀请",
    "earnings": "收益",
    "members": "人员",
    "filter": "筛选：",
    "earningsTrend": "收益趋势",
    "dailyInvites": "每日邀请人数",
    "verifiedHost": "认证主播",
    "inGuild": "已入公会",
    "contact": "联系",
    "level1Earnings": "一级收益",
    "level2Earnings": "二级收益",
    "totalUsd": "总（USD）",
    "loading": "加载中...",
    "noMore": "没有更多了",
    "noData": "暂无数据",
    "back": "返回",
    "tabTypes": "邀请人信息类型",
    "dateFilter": "日期筛选",
    "noToken": "未获取到登录凭证",
    "trendLoadFailed": "趋势数据加载失败",
    "trendLoadFailedRetry": "趋势数据加载失败，请稍后重试",
    "listLoadFailed": "邀请人列表加载失败",
    "listLoadFailedRetry": "邀请人列表加载失败，请稍后重试"
  },
  rewardSource: {
    "title": "奖励明细",
    "pleaseSelect": "请选择",
    "activityEarnings": "活跃",
    "rechargeEarnings": "充值",
    "gameCommission": "游戏",
    "incomeCommission": "收入",
    "back": "返回"
  },
  rewardSourceRule: {
    back: "返回",
    active: {
      title: "邀请活跃规则",
      bindTitle: "如何绑定好友",
      bindSteps: ["第一步：通过邀请活动主页下方邀请按钮，保存图片or复制专属链接。", "第二步：将保存好的图片or专属链接，发送给你的好友。", "第三步：好友通过图片二维码or专属链接，下载并注册，即可绑定好友。"],
      questionTitle: "Q：为什么绑定不上？",
      answer: "a：每一部手机只能有一个账号绑定。可能你的朋友提前绑定过。",
      userTitle: "活跃用户规则",
      userIntro: "你绑定的好友，通过完成每日活跃任务会为你增加活跃用户数。",
      tasks: ["任务1：上麦并开麦2小时。", "任务2：Game流水达到1,000金币。", "必须完成认证。", "完成以上任意一个任务，即可为你提供1个有效活跃用户数。", "每个好友1天只能提供1个有效活跃用户数。"],
      userNotes: ["每个绑定的好友，从注册开始计算，只有前7天可以为你提供有效活跃用户数。", "每个绑定的好友至多只能为你提供7次有效活跃用户数。"],
      rewardTitle: "活跃用户奖励",
      rewardIntro: "当你每天的有效活跃用户数达到一定数量时，可以获得金豆奖励。",
      rewardTableIntro: "奖励如下。",
      rewardTableLabel: "活跃用户金豆奖励表",
      rewardHeaders: ["每日活跃用户", "金豆奖励", "价值（美元）"],
      rewardNotes: ["单日最高可以获得价值70美元的奖励。", "当日奖励，将于次日10点开启手动领取。", "领取位置：直播Tab or直播间 悬浮按钮“奖励”内领取。", "奖励发放后，需要当天领取，否则会过期，有奖励请尽快领取。"],
      noticeTitle: "注意事项",
      notices: ["每一部手机只可有一个绑定。", "绑定的好友必须要完成认证，才可以为你提供活跃用户计数。", "列表中仅展示7天内注册的用户。", "若发现利用不正当手段绑定or刷取用户数量，平台将不予奖励发放；情节严重将进行封号等处理。"]
    },
    game: {
      title: "游戏分佣规则",
      levelTitle: "游戏分佣等级制度",
      levelText: "你、一级成员、以及二级成员，三层团队的总Game流水决定你的等级。流水越高，等级越高，收益越多。",
      rewardTitle: "奖励构成",
      rewards: ["一级分佣：直接从一级成员的Game流水中获得分成收益。", "二级分佣：若一级成员评级比你低，额外从二级成员处获得收益"],
      tierTitle: "游戏分佣等级表",
      tierLabel: "游戏分佣等级表",
      tierHeaders: ["等级", "30天团队总Game流水", "分成比例"],
      tierNote: "你的等级将由你团队的30天Game流水进行评定。",
      assessmentTitle: "奖励发放与等级评定规则",
      assessments: ["每日0点，将会为你统计你团队前30天的流水，为你评定等级。", "并根据你评定的等级为你结算前一天的奖励。"],
      exampleTitle: "简单示例",
      examples: ["你的评级 Lv.5，一级成员产生的流水的 0.5% 会奖励给你。", "你的评级 Lv.5，你的一位一级成员评级 Lv.3，那么这位一级成员带来的二级成员Game流水，将有 0.2% 奖励给你。因为你们评级分成比例的差距为 0.2% (0.5% - 0.3%)。", "若你的评级 Lv.5，你的一位一级成员评级同样是 Lv.5，那么这位一级成员带来的二级成员Game流水将不会给你提供奖励，因为你们的差距为 0 (0.5% - 0.5%)。"],
      detailTitle: "详细示例说明",
      detailTeamTitle: "团队评级计算：",
      detailTeams: [
        { title: "A团队评级", lines: ["自身投注+一级用户投注+二级用户投注。", "A投注+B投注+C投注+D投注+E投注+F投注+G投注       =10M+20M+10M+5M+800M+200M+10M=1055M", "评级为Lv.5，分佣率0.5%。"] },
        { title: "B团队（A的一级成员）", lines: ["B投注+E投注+F投注=20M+800M+200M=1020M", "评级为Lv.5,分佣率0.5%。"] },
        { title: "C团队（A的一级成员）", lines: ["C投注+G投注=20M。", "评级为Lv.2，分佣率0.2%。"] }
      ],
      detailIncomeTitle: "用户A收益情况：",
      detailIncomeGroups: [
        { title: " A 从一级用户 (B, C, D) 获得的直接返利 ：(B自身投注 + C自身投注 + D自身投注) × A的返利比例 = (20M + 10M + 5M) × 0.5% = 35M × 0.5% = 175,000 金币 (折合$17.50 美元)。"},
        { title: "A从二级用户（E、F、G）获得的极差返利：", lines: ["来自 E, F：(A分佣率-B分佣率) × (E+F) = (0.5%-0.5%) × (800M+200M) = $0 美元（B的分佣率与A的分佣率一致，极差为0，所以没有任何奖励）。", "来自 G：(A分佣比例-C分佣比例) × G = (0.5%-0.2%) × 10M = 0.3% × 10M = 30,000 金币 (折合 $3.00 美元)  （A的分佣率比C的分佣率多0.3%，所以会获得G的0.3%的奖励）。"] }
      ]
    },
    income: {
      title: "收入分佣规则",
      levelTitle: "收入分佣等级制度",
      levelText: "你、一级成员、以及二级成员，三层团队的总收入决定你的等级。团队收入越高，等级越高，收益越多。",
      rewardTitle: "奖励构成",
      rewards: ["自身收入。", "一级成员的收入。", "二级成员的收入。"],
      tierTitle: "收入分佣等级表",
      tierLabel: "收入分佣等级表",
      tierHeaders: ["等级", "团队近30天金豆收入", "分佣比例"],
      tierNote: "你的等级，将由你团队的近30天总收入评定等级。",
      sPlusTitle: "S+",
      sPlus: ["若你的团队中，有两名一级成员达到S级，你将会升级为S+。", "将会拥有21%的分佣率。"],
      assessmentTitle: "奖励发放与等级评定规则",
      assessments: ["每日0点，将会为你统计你团队前30天的流水，为你评定等级。", "并根据你评定的等级为你结算前一天的奖励。"],
      exampleTitle: "简单示例",
      examples: ["示例1：你的等级是S，你的任何礼物收入，你都会获得20%的金豆奖励。", "示例2：你的等级是 S，你的一级成员是 A。那么你会获得这位一级成员，以及他带来的二级成员礼物收入的 2% 金豆奖励。因为你们的等级差距是 20% - 18% = 2%。", "示例3：你的等级是 S，你有一位一级成员也是 S。那么你将无法从这位一级成员处获得收益。"],
      noticeTitle: "注意事项",
      notices: ["若你团队中的某位成员加入了公会，那么他将不再计入你的团队收益计算，并且不会提供礼物收入奖励。", "等级根据最近30天的团队礼物收入金豆收益判断。", "必须认证为主播，才可以计算收益"],
      detailTitle: "详细图示说明",
      detailGroups: [
        {
          title: "团队评级计算：",
          items: [
            {
              title: "A团队评级",
              points: [
                { title: "A收入+B收入+C收入+D收入+E收入+F收入=20M+156M+98M+40M+4M+2M=320M。", lines: [] },
                { title: "评级S，分佣率20%", lines: [] }
              ]
            },
            {
              title: "B团队评级",
              points: [
                { title: "B收入+D收入+E收入=156M+40M+4M=200M", lines: [] },
                { title: "评级A，分佣率18%。", lines: [] }
              ]
            },
            {
              title: "C团队（A的一级成员）",
              points: [
                { title: "C收入+F收入=98M+2M=100M", lines: [] },
                { title: "评级A，分佣率18%。", lines: [] }
              ]
            }
          ]
        },
        {
          title: "A收入计算：",
          items: [
            {
              title: "自身收入。",
              points: [
                { title: "A收益×A评级=20M×20%=4,000,000金豆。", lines: [] }
              ]
            },
            {
              title: "一级成员收入。",
              points: [
                { title: "成员B", lines: ['B收入×（A分佣率-B分佣率）=156M×（20%-18%）=3,120,000金豆'] },
                { title: "成员C", lines: ['C收入×（A分佣率-B分佣率）=98M×（20%-18%）=1,960,000金豆'] },
              ]
            },
            {
              title: "二级成员收入。",
              points: [
                { title: "成员D、E（B的成员）", lines: ['（D收入+E收入）×（A分佣率-B分佣率）=（40M+4M）×（20%-18%）=880,000金豆'] },
                { title: "成员F（C的成员）", lines: ['F收入×（A分佣率-B分佣率）=2M×（20%-18%）=40,000金豆s'] },
              ]
            },
            {
              title: "总计",
              points: [
                { title: "自身额外收入：4M金豆。"},
                { title: "邀请极差收入：3.12M+1.96M+0.88M+0.04M=6M。" },
                { title: "总计收入10M金豆。", lines: [] }
              ]
            }
          ]
        }
      ]
    },
    recharge: {
      title: "充值奖励规则",
      cashbackTitle: "充值返利",
      cashback: ["自你的好友注册30天起，他的充值将为你提供充值返利。", "你的好友邀请的好友，自注册30天起，也将会为你提供充值返利。"],
      chainTitle: "关系链",
      chainIntro: "如图：A邀请B，B邀请C，C邀请D。",
      chainAlt: "A、B、C、D邀请关系链示意图",
      chainExamples: ["B充值10,000金币。A将会获得200金币（2%返利）。", "C充值10,000金币。B将会获得200金币（2%返利），A将会获得100金币（1%返利）。", "D充值10,000金币。C将会获得200金币（2%返利），B将会获得100金币（1%返利），A将不再获得来自D的返利。", " 一级直推将会为你提供2%的返利。", "二级间推将会为你提供1%的返利。"],
      validityTitle: "30天有效期",
      validity: ["自被邀请好友注册起30日的所有充值，都将会为他的上级提供返利。", "超过30天后，产生的充值，将不再提供任何返利。"],
      payoutTitle: "奖励发放规则",
      payout: ["用户完成充值后，奖励将会实时发放至你的钱包内。", "充值方式包括：金币直充、代理充值。"]
    }
  },
  rewardSourceDetail: {
    "title": "奖励来源明细",
    "rules": "规则",
    "activityEarnings": "活跃",
    "rechargeEarnings": "充值",
    "gameCommission": "游戏",
    "incomeCommission": "收入",
    "totalEarnings": "总计",
    "yesterdayEarnings": "昨日",
    "todayEstimate": "今日",
    "todayActiveUsers": "有效用户",
    "currentRankReward": "当前奖励",
    "upgradeReward": "再活跃{count}，奖励升级{reward}",
    "maxRewardTier": "已达最高奖励档位",
    "teamRevenue": "30天团队总流水",
    "currentCommission": "当前分佣",
    "upgradeCommission": "需要{flow}流水，升级至{rate}",
    "maxCommissionTier": "已达最高分佣档位",
    "invitedUsers": "近7天邀请用户",
    "all": "全部",
    "active": "活跃",
    "inactive": "未活跃",
    "certified": "已认证",
    "agency": "Agency",
    "micTime": "上麦时长",
    "minutes": "分钟",
    "gameRevenue": "游戏流水",
    "coins": "金币",
    "loading": "加载中...",
    "noMore": "没有更多了",
    "noData": "暂无数据",
    "total": "总计",
    "last7Days": "近7天",
    "yesterday": "昨日",
    "today": "今日",
    "level1Commission": "一级分佣",
    "level2Commission": "二级分佣",
    "totalIncome": "总收入",
    "commissionRate": "分佣比例",
    "upgradeGap": "距升级差{amount}",
    "activeHelpUpdate": "10-15分钟更新数据",
    "activeHelpReward": "奖励于次日10点，在“首页-奖励”页面处领取",
    "rechargeHelpUpdate": "10-15分钟更新数据",
    "rechargeHelpReward": "用户充值后，奖励立即到账",
    "gameHelpUpdate": "10-15分钟更新数据",
    "gameHelpReward": "奖励次日系统发放",
    "roomHelpUpdate": "10-15分钟更新数据",
    "roomHelpCommission": "包含：你的、一级成员、二级成员的收入分佣",
    "roomHelpReward": "奖励次日系统发放",
    "back": "返回",
    "viewHelp": "查看说明",
    "todayEstimateHelp": "今日预估说明"
  },
};
